import img1 from '@/assets/screen_img/قائمة العملاء.png';
import img2 from '@/assets/screen_img/اضافة عميل - طلب خدمة.png';
import img3 from '@/assets/screen_img/الخدمات - CRM.png';
import img4 from '@/assets/screen_img/قائمة الخدمات- CRM.png';
import img5 from '@/assets/screen_img/الشكاوي.png';
import img6 from '@/assets/screen_img/تقرير CRM.png';
import fms1 from '@/assets/screen_img/fms1.jpeg';
import fms2 from '@/assets/screen_img/fms2.jpeg';
import fms3 from '@/assets/screen_img/fms3.jpeg';
import fms4 from '@/assets/screen_img/fms4.jpeg';
import fms5 from '@/assets/screen_img/fms5.jpeg';
import fms6 from '@/assets/screen_img/fms6.png';

export const reviews = [{ img: img4 }, { img: img5 }, { img: img3 }, { img: img1 }, { img: img2 }, { img: img6 }];
export const Fmsreviews = [{ img: fms4 }, { img: fms5 }, { img: fms3 }, { img: fms1 }, { img: fms2 }, { img: fms6 }];
